/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import clsx from "clsx";
import {useTranslation} from "react-i18next";
import {PackageItemPersonType} from "types/enums/PackageItemPersonType";
import {PackageCategory} from "types/enums/PackageCategory";
import FeatherIcon from "components/FeatherIcon";

interface BookingPackagesCreditsDriverInfoProps {
    i: number;
    personType: PackageItemPersonType;
    category?: PackageCategory | null;
    children?: React.ReactNode | null;
}

const BookingPackagesCreditsDriverInfo = ({ i, personType, category, children }: BookingPackagesCreditsDriverInfoProps) => {
    const { t } = useTranslation();

    const showPersonType = category && [
        PackageCategory.Action,
        PackageCategory.School,
        PackageCategory.FerienPass
    ].includes(category);

    return (
        <div className={"flex flex-row items-center justify-start space-x-1.5 xl:space-x-2"}>
            <span className={"flex items-center justify-center w-[28px] xl:w-[30px] h-[28px] xl:h-[30px] rounded-full bg-[#F1F2FA]"}>
                <FeatherIcon
                    name={"user"}
                    className={clsx(
                        "w-[18px] h-[18px] flex-none",
                        personType === PackageItemPersonType.Adult ? "text-[#3E52C7]" : "text-[#79D00E]"
                    )}
                    strokeWidth={3}
                />
            </span>
            <div className={"flex flex-col justify-center items-start shrink-0"}>
                <div className={"leading-none"}>
                    <span className={"font-bold text-xs sm:text-sm lg:text-xs text-black"}>
                        {i + 1}. {t("person")}
                    </span>
                    {showPersonType && (
                        <span className={"text-[9px] xl:text-[10px] text-gray-500 font-medium text-center"}>{t(personType)}</span>
                    )}
                </div>
                {children}
            </div>
        </div>
    );
};

export default BookingPackagesCreditsDriverInfo;
